import React, { useEffect } from "react";
import { UserNavBar } from "./components/molecules/UserNavBar/UserNavBar";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter } from "react-router-dom";
import { Router } from "./routes";
import { Provider } from "react-redux";
import { store } from "./app/store";

function App() {
  console.log(process.env.REACT_APP_BASE_URL);
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <UserNavBar />
          <CssBaseline />
          <Router />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
